import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import workData from '../../data/workExperience.json'

const WorkExperience = () => {
  const navigate = useNavigate()

  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)

    return () => clearTimeout(timeoutId)
  }, [])

  const handleReportClick = (index) => {
    navigate(`/work/report/${index}`)
  }

  return (
    <div className="work-page">
      <div className="work-container container">
        <h1 className="page-title">
          <AnimatedLetters
            letterClass={letterClass}
            strArray={['W', 'o', 'r', 'k', ' ', 'E', 'x', 'p', 'e', 'r', 'i', 'e', 'n', 'c', 'e']}
            idx={15}
          />
        </h1>

        <div className="work-list">
          {workData && workData.length ? (
            workData.map((item, idx) => (
              <article className="work-item" key={idx}>
                <header className="work-header">
                  <h2 className="role">{item.role}</h2>
                  <div className="meta">{item.company} • {item.location} • <span className="dates">{item.start} — {item.end || 'Present'}</span></div>
                </header>

                <div className="reports">
                  <button className="btn-link" onClick={() => handleReportClick(idx)}>
                    View Work Term Report
                  </button>
                </div>
              </article>
            ))
          ) : (
            <p>No work experience added yet.</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default WorkExperience
